import React from 'react';
import { useTranslation } from 'react-i18next';
import { List, Image } from '@chakra-ui/react';

type Props = {};

export const FireFox = (props: Props) => {
    const { t } = useTranslation();
    return (
        <List.Root as="ol" listStyle="decimal" marginLeft={4}>
            <List.Item _marker={{ color: 'inherit' }}>{t('operatingInstructionsScreen.firefox.one')}</List.Item>
            <List.Item _marker={{ color: 'inherit' }}>{t('operatingInstructionsScreen.firefox.two')}</List.Item>
            <List.Item _marker={{ color: 'inherit' }}>{t('operatingInstructionsScreen.firefox.three')}</List.Item>
            <Image src="/img/firefox/screen.png" marginTop={4} marginBottom={4} alt="image" />
            <List.Item _marker={{ color: 'red' }} color="red">
                {t('operatingInstructionsScreen.firefox.four')}
            </List.Item>
            <List.Item _marker={{ color: 'red' }} color="red">
                {t('operatingInstructionsScreen.firefox.five')}
            </List.Item>
            <List.Item _marker={{ color: 'red' }} color="red">
                {t('operatingInstructionsScreen.firefox.six')}
            </List.Item>
            <List.Item _marker={{ color: 'red' }} color="red">
                {t('operatingInstructionsScreen.firefox.seven')}
            </List.Item>
        </List.Root>
    );
};
